import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {unregister} from './registerServiceWorker';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import {navigation, scene, step, tab, menu, minitour, orientation} from "./reducers";
import { createBrowserHistory } from 'history'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { LocalizeProvider, localizeReducer } from 'react-localize-redux'

const history = createBrowserHistory({ basename: window.public_url});

const store = createStore(connectRouter(history)(combineReducers({navigation: navigation, scene: scene, step: step, tab: tab, menu: menu, minitour: minitour, orientation: orientation,  localize: localizeReducer})), composeWithDevTools(applyMiddleware(routerMiddleware(history))));

ReactDOM.render(
  <Provider store={store}>
    <LocalizeProvider store={store}>
      <App history={history} />
    </LocalizeProvider>
  </Provider>, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js